<template>
  <CFooter :fixed="false">
    <div>
      Mail Update
      <!-- <span id="clock" class="ml-1">{{this.$moment().format('DD/MM/y')}}</span> -->
    </div>
    <div class="ml-auto">
      <span class="mr-1">Desarrollado por <b><a href="https://infoguia.com/" target="_blank">Infoguia</a></b></span>
      <span class="ml-1">{{new Date().getFullYear()}}</span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter',
  data() {
			return {};
		},
  created(){},
  methods: {},
}
</script>
